import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=112ae8c0"
import script from "./ErrorHandler.vue?vue&type=script&lang=js"
export * from "./ErrorHandler.vue?vue&type=script&lang=js"
import style0 from "./ErrorHandler.vue?vue&type=style&index=0&id=112ae8c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports